import { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

/**
 * /r/aff/:slug?c=<campaign_id>
 * Records an affiliate click, drops a `cyn_aff` cookie for downstream claim
 * attribution, then forwards the shopper to the campaign's coupon detail page
 * (or destination URL) so they can claim their code.
 */
export default function AffiliateRedirect() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const campaignId = params.get("c");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get(`/track/aff/${slug}?c=${encodeURIComponent(campaignId || "")}`);
        // Set attribution cookie for 30 days (client-side; backend claim endpoint also reads ?aff)
        document.cookie = `cyn_aff=${slug}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=Lax`;
        if (!mounted) return;
        // Forward to the coupon detail page with aff param preserved
        if (data.coupon_path) {
          navigate(`${data.coupon_path}?aff=${slug}`, { replace: true });
          return;
        }
        if (data.destination) {
          window.location.replace(data.destination);
          return;
        }
        navigate("/coupons", { replace: true });
      } catch (_e) {
        navigate("/coupons", { replace: true });
      }
    })();
    return () => { mounted = false; };
  }, [slug, campaignId, navigate]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center text-slate-500" data-testid="aff-redirect">
      Preparing your Cyannect deal…
    </div>
  );
}
